// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useModuleParty } from '../../contexts/ModuleContext';
import useCollateralAgreementRequests from '../queries/collateral/collateral/useCollateralAgreementRequests';

export const useInboundCollateralAgreementRequestCount = () => {
  const party = useModuleParty();
  const requests = useCollateralAgreementRequests();
  return requests.data?.filter((r) => r.payload.counterparty === party)?.length || 0;
};
